export const LiraContainerIds = {
  belowTheRating: 'userprofile-belowtheratings',
};
